(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tef-product-tag-picker')) {
    customElements.define('tef-product-tag-picker', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        const tagsTemplate = this.querySelector('[data-available-tags]');
        let availableTags = [];
        try { availableTags = JSON.parse(tagsTemplate.content.textContent) || []; }
        catch { /* Leave saved selections usable if collection data is unavailable. */ }
        const selected = new Set((this.dataset.initialTags || '').split(',').map(tag => tag.trim()).filter(Boolean));
        const available = new Set(availableTags);
        const tags = [...new Set([...availableTags, ...selected])].sort((a, b) => a.localeCompare(b));
        const options = this.querySelector('[data-tag-options]');
        const output = this.querySelector('[data-tag-output]');
        const status = this.querySelector('[data-tag-status]');
        const search = this.querySelector('[data-tag-search]');
        const emptyMessage = this.querySelector('[data-no-tags]');
        const rows = [];
        const sync = () => {
          output.value = [...selected].join(', ');
          status.textContent = `${selected.size} tag${selected.size === 1 ? '' : 's'} selected. Copy and paste into Tags to include to apply.`;
        };
        const fragment = document.createDocumentFragment();
        for (const tag of tags) {
          const label = document.createElement('label');
          label.className = 'tef-tag-picker__option';
          const checkbox = document.createElement('input');
          checkbox.type = 'checkbox';
          checkbox.value = tag;
          checkbox.checked = selected.has(tag);
          const name = document.createElement('span');
          name.textContent = tag;
          if (!available.has(tag)) label.title = 'Saved tag not found in the selected collection';
          label.append(checkbox, name);
          checkbox.addEventListener('change', () => {
            if (checkbox.checked) selected.add(tag);
            else selected.delete(tag);
            sync();
          });
          rows.push({ label, checkbox, tag });
          fragment.append(label);
        }
        options.append(fragment);
        emptyMessage.hidden = rows.length > 0;
        search.addEventListener('input', () => {
          const query = search.value.trim().toLocaleLowerCase();
          let visible = 0;
          for (const row of rows) {
            row.label.hidden = !row.tag.toLocaleLowerCase().includes(query);
            if (!row.label.hidden) visible++;
          }
          emptyMessage.hidden = visible > 0;
        });
        this.querySelector('[data-clear-tags]').addEventListener('click', () => {
          selected.clear();
          for (const row of rows) row.checkbox.checked = false;
          sync();
          status.textContent = 'Selection cleared. Empty Tags to include in the section settings to show all products.';
        });
        this.querySelector('[data-copy-tags]').addEventListener('click', async () => {
          output.focus();
          output.select();
          try {
            await navigator.clipboard.writeText(output.value);
            status.textContent = selected.size ? 'Copied. Paste into Tags to include in the section settings, then save.' : 'No tags selected. Empty Tags to include in the section settings to show all products.';
          } catch {
            status.textContent = 'Automatic copy is unavailable here. Copy the highlighted text with Ctrl+C or Cmd+C, then paste into Tags to include.';
          }
        });
        sync();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
